module.exports = __webpack_public_path__ + "img/bookshelf13.d2e175ef.jpg";